module.exports = __webpack_public_path__ + "static/media/Smaragdenia_Filaki_2.9e9c973c.jpg";